/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-05-21 16:02:42
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-03-07 14:30:53
 * @FilePath: \qctsw-vue\packages\app\src\logic\complaint\collective.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { LOAD_STATE } from '@/shared/types'
import { getCollectiveDetailAllImageApi, getCollectiveDetailApi, getCollectiveRelativeComplaintListApi, getComplainScoreApi } from '@/server'
import type { CollectiveDetailResponse, CollectiveRelativeComplaintResponse } from '@/server/types'
import { usePagination } from '@/composables/usePagination'

export function logicCollectiveDetail() {
  const state = ref(LOAD_STATE.INIT)
  const detailData = ref<ReturnType<typeof format> | null>(null)

  function format(data: CollectiveDetailResponse) {
    return {
      ...data,
    }
  }

  async function getDetail(id: string) {
    const res = await useLoadState({
      key: `集体投诉详情-${id}`,
      state,
      fn: () => getCollectiveDetailApi(id),
    })

    const complainScore = await getComplainScoreApi(id)

    if (!res?.data)
      return

    detailData.value = format(res?.data)
    detailData.value.complainScore = complainScore?.data || []
  }

  return {
    state,
    detailData,
    getDetail,
  }
}

export function logicCollectiveDetailAllImage() {
  const data = ref<string[]>([])
  const pagination = usePagination({
    type: 'up',
    pageSize: 20,
    pageNum: 2,
    onlyClient: true,
    request: (page, params: { collectiveId: string } = { collectiveId: '-1' }) => getCollectiveDetailAllImageApi({ ...page, ...params }),
  })

  async function getPage(page: number | string = 1, params: { collectiveId: string }) {
    const p = Number.isNaN(Number(page)) ? 1 : Number(page)
    const { list } = await pagination.loadPaginationData(p, params) || {}
    if (!list)
      return
    data.value.push(...list)
  }
  return {
    data,
    pagination,
    getPage,
    state: computed(() => pagination.pagination.status),
  }
}

export function logicCollectiveRelativeComplaintList() {
  const data = ref<CollectiveRelativeComplaintResponse[]>([])
  const pagination = usePagination({
    type: 'up',
    pageSize: 20,
    key: `集体投诉相关投诉列表`,
    request: (page, params: { collectiveId: string } = { collectiveId: '-1' }) => getCollectiveRelativeComplaintListApi({ ...page, ...params }),
  })

  async function getPage(page: number | string = 1, params: { collectiveId: string }) {
    const p = Number.isNaN(Number(page)) ? 1 : Number(page)
    const { list } = await pagination.loadPaginationData(p, params) || {}
    if (!list)
      return
    data.value.push(...list)
  }
  return {
    data,
    pagination,
    getPage,
    state: computed(() => pagination.pagination.status),
  }
}
